<template>
  <div class="client-layout" :class="themeClass">
    <ClientSidebar />
    <div class="main-content">
      <ClientTopbar />
      <main class="content-area">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import ClientSidebar from '@/components/ClientSidebar.vue'
import ClientTopbar from '@/components/ClientTopbar.vue'
import themeManager from '@/store/theme'

export default {
  name: 'ClientLayout',
  components: {
    ClientSidebar,
    ClientTopbar,
  },
  computed: {
    themeClass() {
      return themeManager.themeClass;
    }
  },
  mounted() {
    // Asegurar que el tema se aplique cuando se carga el layout
    themeManager.init();
  }
}
</script>

<style scoped>
.client-layout {
  display: flex;
  background-color: var(--bg-light);
  color: var(--text-primary);
  min-height: 100vh;
}

/* Tema oscuro para el layout */
.dark-theme .client-layout {
  background-color: var(--bg-dark);
}

/* Sidebar ocupa un ancho fijo */
.client-layout > :first-child {
  width: 250px;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-color: var(--bg-light);
  border-right: 1px solid var(--border-color);
}

/* Tema oscuro para sidebar */
.dark-theme .client-layout > :first-child {
  background-color: var(--bg-dark);
}

/* Contenido principal a la derecha del sidebar */
.main-content {
  margin-left: 250px;
  width: calc(100% - 250px);
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: var(--bg-light);
}

/* Tema oscuro para main content */
.dark-theme .main-content {
  background-color: var(--bg-dark);
}

/* Topbar fijo en la parte superior del main content */
.main-content > .client-topbar {
  flex: 0 0 auto;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1000;
}

/* Contenido debajo del topbar, scrollable */
.content-area {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 20px;
  background-color: var(--bg-light);
}

/* Tema oscuro para content area */
.dark-theme .content-area {
  background-color: var(--bg-dark);
}
</style>
